import { useMutation, useQuery } from "@apollo/client";
import { CREATE_SUPPORT_TICKET, GET_SUPPORT_TICKET_MAPPINGS } from "./customer-support.mutation";
import {
  CreateSupportTicketInput,
  CreateSupportTicketResult,
  SupportTicketMapping,
} from "./customer-support.interface";

export const useCreateSupportTicket = () => {
  const [createTicket, { data, loading, error }] = useMutation<
    { createSupportTicket: CreateSupportTicketResult }
  >(CREATE_SUPPORT_TICKET);

  const submitTicket = (input: CreateSupportTicketInput) =>
    createTicket({
      variables: {
        createSupportTicketData: {
          petIds: input.petIds,
          subjectOfInquiry: input.subjectOfInquiry,
          description: input.description,
          source: input.source,
          device: input.device,
          ...(input.attachment ? { attachment: input.attachment } : {}),
        },
      },
    });

  return {
    submitTicket,
    data: data?.createSupportTicket,
    loading,
    error,
  };
};

export const useSupportTicketMappings = () => {
  const { data, loading, error } = useQuery<
    { getSupportTicketMappings: SupportTicketMapping[] }
  >(GET_SUPPORT_TICKET_MAPPINGS);

  return {
    mappings: data?.getSupportTicketMappings ?? [],
    loading,
    error,
  };
};
